import type { DividerValue } from '@vedalib/editor/lib/elements'
import { CONFIG_ELEMENTS, DividerViews } from '@vedalib/editor/lib/elements'

import { DEMO_MODE } from 'services/Store/Project/constants'

import DemoWrapper from '../../decorators/DemoWrapper'
import Element from './DividerElement'
import type { DividerDemoType } from './dividerTypes'

const DEMO_VALUE_SOLID: DividerValue = { dividerType: 'solid', dividerView: DividerViews.double }
const DEMO_VALUE_DOTTED: DividerValue = { dividerType: 'dotted', dividerView: DividerViews.double }
const DEMO_VALUE_DASHED: DividerValue = { dividerType: 'dashed', dividerView: DividerViews.double }
const DEMO_VALUE_NUMBERED: DividerValue = {
  dividerType: 'solid',
  isNumbered: true,
  dividerNumber: '1',
}

const DemoSolid: DividerDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.divider.type}-solid-demo`,
        type: CONFIG_ELEMENTS.divider.type,
        value: DEMO_VALUE_SOLID,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={{ ...styles, root: { width: '100%' } }}
    />
  </DemoWrapper>
)

const DemoDashed: DividerDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.divider.type}-dashed-demo`,
        type: CONFIG_ELEMENTS.divider.type,
        value: DEMO_VALUE_DASHED,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={{ ...styles, root: { width: '100%' } }}
    />
  </DemoWrapper>
)

const DemoDotted: DividerDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.divider.type}-dotted-demo`,
        type: CONFIG_ELEMENTS.divider.type,
        value: DEMO_VALUE_DOTTED,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={{ ...styles, root: { width: '100%' } }}
    />
  </DemoWrapper>
)

const DemoNumbered: DividerDemoType = ({ styles, fonts, feedback }) => (
  <DemoWrapper>
    <Element
      element={{
        id: `${CONFIG_ELEMENTS.divider.type}-none-demo`,
        type: CONFIG_ELEMENTS.divider.type,
        value: DEMO_VALUE_NUMBERED,
        style: {},
        font: {},
        feedback: {},
      }}
      feedback={feedback}
      font={fonts}
      mode={DEMO_MODE}
      styles={{ ...styles, root: { width: '100%' } }}
    />
  </DemoWrapper>
)

export { DemoSolid, DemoDashed, DemoDotted, DemoNumbered }
